import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import Services from "./components/Services";
import AIAnswerBlock from "./components/AIAnswerBlock";
import Process from "./components/Process";
import WhyChooseUs from "./components/WhyChooseUs";
import ServiceAreas from "./components/ServiceAreas";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import CTAForm from "./components/CTAForm";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <Hero />
      <TrustBar />
      <Services />
      <WhyChooseUs />
      <AIAnswerBlock />
      <Process />
      <Testimonials />
      <ServiceAreas />
      <FAQ />
      <CTAForm />
      <Footer />
    </main>
  );
}
